<style scoped>
.payment-information {
  display: flex;
  /* align-items: center; */
  width: 100%;
  margin-bottom: 20px;
}

.pay-left {
  padding: 20px;
}

.invoice-item {
  width: 50%;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.invoice-name {
  /* flex: 1; */
  width: 113px;
  flex-shrink: 0;
  text-align: right;
}

.invoice-box {
  display: flex;
  justify-content: space-between;
}

.invoice-content {
  width: 152px;
  word-break: break-all;
  white-space: normal;
  text-align: left;
}

.pay-left {
  width: 100%;
  padding: 20px 20px 10px 20px;
}

.pay-right {
  width: 10%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.el-icon-check {
  margin-bottom: 20px;
}

/* 上传 */
/deep/.el-upload--text {
  display: block;
}

/deep/.el-upload-list__item:first-child {
  margin-top: 0;
}

.el-icon-check {
  margin-bottom: 20px;
  cursor: pointer;
}

.el-icon-edit {
  margin-bottom: 20px;
  cursor: pointer;
}

.el-drawer__body {
  padding: 0 40px;
}

.check-img {
  cursor: pointer;
  color: #4fa1a4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-dialog-div {
  height: 80vh;
}

.show-img {
  border: none;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* .drawer-inform-div {
  margin: auto;
    display: flex;
    width: 100%;
    margin-right: 20px;
    flex-shrink: 0;
  } */
.button-area {
  padding-left: 0 !important;
}

.scan-box {
  display: flex;
  align-items: center;
}

.scan-img {
  width: 150px;
  height: 90px;
  border-radius: 4px;
}
</style>
<template>
  <div>
    <!-- 到账填报抽屉 -->
    <el-drawer title="发票填报" :visible.sync="showInvoice" :direction="direction" size="50%" :before-close=closeChage>
      {{ invoiceFillData.id }}
      <div class="drawer-inform">
        <div class="drawer-inform-div dw100">
          <span class="inform-title">供应商: </span><span class="inform-content">{{ invoiceFillData.supplierName }}</span>
        </div>
      </div>
      <div class="drawer-inform">
        <div class="drawer-inform-div">
          <span class="inform-title">年度: </span><span class="inform-content">{{ invoiceFillData.year }}</span>
        </div>
        <div class="drawer-inform-div">
          <span class="inform-title">月份: </span><span class="inform-content">{{ invoiceFillData.month }}</span>
        </div>
      </div>
      <div class="drawer-inform">
        <div class="drawer-inform-div">
          <span class="inform-title">应开票: </span><span class="inform-content">{{ invoiceFillData.receiptAmount | numDigit
          }}元</span>
        </div>
        <div class="drawer-inform-div">
          <span class="inform-title">已开票: </span><span class="inform-content">{{ invoiceFillData.invoiceAmount | numDigit
          }}元</span>
        </div>
        <div class="drawer-inform-div">
          <span class="inform-title">待开票: </span><span class="inform-content">{{ (invoiceFillData.receiptAmount -
            invoiceFillData.invoiceAmount) | numDigit }}元</span>
        </div>
      </div>
      <p class="t-left font-S16">发票信息</p>
      <div class="button-area pd0 mb30">
        <el-button size="medium" type="info" @click="invoiceAdd">新增</el-button>
      </div>
      <div class="payment-information" v-for="(item, index) in invoiceList" :key="index">
        <div class="pay-left invoice-left border-d6">
          <div class="invoice-box">
            <div class="invoice-item">
              <div class="invoice-name">发票类型：</div>
              <div class="invoice-content">
                <el-select v-if="item.isEdit" v-model="item.invoiceType" placeholder="请选择" :clearable="true">
                  <el-option label="增值税普通发票" value="1"></el-option>
                  <el-option label="增值税专用发票" value="2"></el-option>
                </el-select>
                <span class="t-left" v-else>{{ item.invoiceType | getInvoiceType }}</span>
              </div>
            </div>
            <div class="invoice-item">
              <div class="invoice-name">开票日期：</div>
              <div class="invoice-content">
                <el-date-picker v-if="item.isEdit" v-model="item.invoiceDate" type="date" placeholder="选择日期"
                  style="width: 100%">
                </el-date-picker>
                <span class="t-left" v-else>{{ item.invoiceDate | getDate }}</span>
              </div>
            </div>
          </div>
          <div class="invoice-box">
            <div class="invoice-item">
              <div class="invoice-name">开票金额（元）：</div>
              <div class="invoice-content">
                <el-input v-if="item.isEdit" v-model="item.invoiceAmount" placeholder="请输入" :clearable="true"></el-input>
                <span class="t-left" v-else>{{ item.invoiceAmount | numDigit }}</span>
              </div>
            </div>
            <div class="invoice-item">
              <div class="invoice-name">发票号：</div>
              <div class="invoice-content">
                <el-input v-if="item.isEdit" v-model="item.invoiceNo" placeholder="请输入" :clearable="true"></el-input>
                <span class="t-left" v-else>{{ item.invoiceNo }}</span>
              </div>
            </div>
          </div>
          <div class="invoice-box">
            <div class="invoice-item w100f">
              <div class="invoice-name">发票扫描件：</div>
              <div class="invoice-content scan-box">
                <div class="ml16 fontC-4fa1a4 c-pointer" v-if="!item.isEdit" @click="getPdf(item.scanCopy)">
                  点击查看
                </div>
                <!-- <el-image
                      v-if="!item.isEdit"
                        ref="image"
                        class="borderR6 mr15"
                        style="width: 150px; height: 90px;flex-shrink:0;"
                        :src="item.scanCopy"
                        :preview-src-list="srcList"
                      >
                      </el-image> -->
                <el-upload v-if="item.isEdit" action="#" :on-preview="handlePreview" :on-remove="handleRemove"
                  :on-exceed="handleExceed" :before-remove="beforeRemove" :headers="token" multiple :limit="1"
                  accept=".png,.jpg,.gif,.jpeg,.jfif,.pdf,.PDF" :file-list="fileList"
                  :http-request="(file) => uploadImage(file, index)">
                  <el-button v-if="!item.scanCopy">点击上传</el-button>
                  <div class="ml16 fontC-4fa1a4 c-pointer" v-if="item.scanCopy">点击更换</div>
                </el-upload>
                <!-- <div :class="item.scanCopy ? 'check-img' : ''" v-else :title="item.scanCopy" @click="imgClick()">
                        {{ item.scanCopy ? item.scanCopy : '暂无附件' }}
                      </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="pay-right">
          <p class="fontC-409EFF c-pointer" @click="updateInvoiceDetail(item, index)">
            {{ item.isEdit ? '保存' : '编辑' }}
          </p>
          <p class="fontC-red c-pointer" @click="deleteInvoiceDetail(item.guid)">删除</p>
          <!-- <i class="el-icon-delete mb30" @click="deleteInvoiceDetail(item.guid)" title="删除"></i>
                <i :class="item.isEdit ? 'el-icon-check mb70' : 'el-icon-edit mb70'" :title="item.isEdit ? '保存' : '编辑'" @click="updateInvoiceDetail(item, index)"></i
                > -->
        </div>
      </div>
    </el-drawer>
    <el-dialog title="附件查看" :visible.sync="getPdfFile" fullscreen :append-to-body="true" :close-on-click-modal="false">
      <div class="el-dialog-div">
        <iframe :src="pdfSrc" frameborder="0" style="width: 100%; height: 100%"></iframe>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import { parse } from 'qs';
export default {
  props: ['invoice'],
  data() {
    return {
      showImage: false,
      url: `${route}/ms-common-admin-cloud-service/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      showInvoice: false,
      invoiceList: [],
      fileList: [],
      direction: 'rtl',
      value: '',
      imageName: '',
      paymentState: '',
      invoiceFillData: {},
      srcList: [],
      pdfSrc: '',
      getPdfFile: false,
      invoiceType: '',
    };
  },
  watch: {
    invoice: {
      handler(newValue, oldValue) {
        this.invoiceFillData = newValue;
        this.getContractInfo(this.invoiceFillData.supplierGuid);
      },
      deep: true,
    },
  },
  created() {
    this.addIsEdit();
  },
  methods: {
    imgClick() {
      const btn = this.$refs.image[0].$el.getElementsByTagName('img')[0];
      console.log(btn);
      const event = new MouseEvent('click');
      btn.dispatchEvent(event);
    },
    //更新发票信息
    updateInvoice() {
      this.invoiceFillData.invoiceAmount = this.invoiceList.reduce((total, current) => {
        return total + Number(current.invoiceAmount);
      }, 0);
    },
    //查询发票填报列表
    getContractInfo(supplierGuid) {
      let self = this;
      return new Promise((resolve, reject) => {
        self.api
          .get(`/ms-data-business-service/contract-detail/get-contract-info?supplierGuid=` + supplierGuid)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.invoiceType = res.data.data.invoiceType;
            } else {
              self.$message.error(res.data.msg);
            }
          });
      });
    },
    //添加isedit
    addIsEdit() {
      let self = this;
      self.invoiceList.forEach((item, index) => {
        item['isEdit'] = false;
      });
    },
    //对数据进行日期排序
    sortDataArray(dataArray) {
      const self = this;
      return dataArray.sort((a, b) => {
        return self.$moment(b.invoiceDate).unix() - self.$moment(a.invoiceDate).unix();
      });
    },
    // 抽屉关闭事件
    closeChage(done) {
      this.arriveData = []
      done();
    },
    //查询发票填报列表
    getInvoice(operatingCostsGuid) {
      let self = this;
      return new Promise((resolve, reject) => {
        self.api
          .get(
            `/ms-data-business-service/operating-invoice/select-operating-invoice-info?operatingCostsGuid=` +
            operatingCostsGuid,
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.invoiceList = self.sortDataArray(res.data.data);
              this.updateInvoice();
              if (self.invoiceList !== null) {
                self.invoiceList.forEach((item) => {
                  item.scanCopy = JSON.parse(item.scanCopy);
                  self.srcList.push(item.scanCopy);
                });
                resolve();
                console.log(res.data);
              } else {
                self.$message.error(res.data.msg);
              }
            }
          });
      });
    },
    showImages() {
      this.showImage = true;
    },
    //点击查看pdf
    getPdf(scanCopy) {
      let self = this;
      if (!scanCopy) {
        return;
      }
      self.getPdfFile = true;
      if (self.invoiceList == '' || self.invoiceList == null || self.invoiceList == undefined) {
        self.pdfSrc = '';
      } else {
        self.pdfSrc = scanCopy;
      }
    },
    // 信息传递到主表
    updateToFill() {
      let self = this;
      return new Promise((resolve, reject) => {
        const invoiceAmount = self.invoiceList.reduce((total, current) => {
          return total + Number(current.invoiceAmount);
        }, 0);

        let promise = {
          guid: self.invoiceFillData.guid,
          medGuid: self.$store.state.medGuid,
          supplierGuid: self.invoiceFillData.supplierGuid,
          invoiceAmount: Number(invoiceAmount),
          invoiceState: '3',
        };
        if (invoiceAmount >= Number(self.invoiceFillData.receiptAmount)) {
          promise.invoiceState = '1';
        } else if (invoiceAmount > 0 && invoiceAmount < Number(self.invoiceFillData.receiptAmount)) {
          promise.invoiceState = '2';
        } else {
          promise.invoiceState = '3';
        }
        self.api.put('/ms-data-business-service/operating-costs/update-operating-costs-list', promise).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            resolve();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      });
    },
    //新增或者修改到账填报
    updateInvoiceDetail(item, index) {
      let self = this;
      const flag = JSON.parse(JSON.stringify(self.invoiceList));
      self.invoiceList = flag;
      let promise = {
        guid: '',
        operatingCostsGuid: self.invoiceFillData.guid,
        invoiceNo: item.invoiceNo,
        invoiceDate: item.invoiceDate && self.$moment(item.invoiceDate).format('YYYY-MM-DD'),
        invoiceAmount: item.invoiceAmount,
        invoiceType: item.invoiceType,
        scanCopy: JSON.stringify(item.scanCopy),
      };
      if (item.guid) {
        promise.guid = item.guid;
      } else {
        promise.guid = '';
      }
      const invoiceAmount = self.invoiceList.reduce((total, current) => {
        return total + Number(current.invoiceAmount);
      }, 0);
      // if (invoiceAmount > self.invoiceFillData.receiptAmount) {
      //   self.$message.error('已开票总金额不能大于到应开票总金额！');
      //   return;
      // } else if (item.invoiceAmount <= 0) {
      //   self.$message.error('已开票金额必须大于0！');
      //   return;
      // }
      if (item.invoiceAmount <= 0) {
        self.$message.error('已开票金额必须大于0！');
        return;
      } else if (item.invoiceDate == '' || item.invoiceDate == null) {
        self.$message.error('开票日期不能为空！');
        return;
      }
      // else if (item.scanCopy == '') {
      //   self.$message.error('请上传扫描件！');
      //   return;
      // }
      else if (item.invoiceNo == '') {
        self.$message.error('请输入发票号！');
        return;
      } else if (item.invoiceType == '' || item.invoiceType == null) {
        self.$message.error('请选择发票类型！');
        return;
      }
      if (flag[index].isEdit) {
        flag[index].isEdit = false;
        self.api
          .put('/ms-data-business-service/operating-invoice/insert-or-update-operating-invoice', [promise])
          .then(async (res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('保存成功!');
              console.log(self.$emit);
              await self.getInvoice(self.invoiceFillData.guid);
              self.updateToFill().then(function () {
                self.$emit('refreshData');
              });
            } else {
              self.$message.error(res.data.msg);
            }
          });
      } else {
        const isEdit = flag.some((item) => item.isEdit);
        if (isEdit) {
          self.$message.error('请先保存已编辑的数据!');
        } else {
          flag[index].isEdit = true;
        }
      }
    },
    //删除到账填报
    deleteInvoiceDetail(guid) {
      let self = this;
      self.api
        .postJson('/ms-data-business-service/operating-invoice/delete-operating-invoice?guid=' + guid)
        .then(async (res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('删除成功！');
            await self.getInvoice(self.invoiceFillData.guid);
            self.updateToFill().then(function () {
              self.$emit('refreshData');
            });
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //上传图片
    uploadImage(file, index) {
      let self = this;
      let formData = new FormData();
      formData.append('image', file.file);
      console.log(self.fileList);
      self.api.postImage(self.url, formData).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.invoiceList[index].scanCopy = res.data.data;
          self.fileList = [];
          this.$message({
            message: '上传成功',
            type: 'success',
          });

          console.log(res.data);
        } else {
          self.fileList = [];
          self.$message.error(res.data.msg);
        }
      });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      let self = this;
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`,
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    //新增发票填报
    invoiceAdd() {
      let self = this;
      const isEdit = self.invoiceList.some((item) => item.isEdit);
      if (isEdit) {
        self.$message.error('请先保存已编辑的数据!');
      } else {
        let newInvoice = {
          invoiceDate: '',
          invoiceAmount: '',
          invoiceType: self.invoiceType,
          invoiceNo: '',
          scanCopy: '',
          isEdit: true,
        };
        self.invoiceList.unshift(newInvoice);
        console.log(self.invoiceList);
      }
    },
  },
};
</script>